import React, { createContext, useState } from 'react';

export const SwimAThonFiltersStateContext = createContext();

const INITIAL_STATE = {
  filterObject: {},
  backToSystem: 'SATSearch'
};

const SwimAThonFiltersContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <SwimAThonFiltersStateContext.Provider value={stateHook}>
      {children}
    </SwimAThonFiltersStateContext.Provider>
  );
};

export default SwimAThonFiltersContextProvider;